import {
  Heart,
  Phone,
  MapPin,
  Clock,
  Video,
  BookOpen,
  Users,
  Home,
  MicVocal,
  Smile,
} from "lucide-react";
import { SiInstagram, SiWhatsapp } from "@icons-pack/react-simple-icons";

export const getMenuItems = (translations) => [
  {
    title: translations.menu.home,
    link: "#home",
    icon: <Home className="w-4 h-4" />,
  },
  {
    title: translations.menu.intro,
    link: "#intro",
    icon: <BookOpen className="w-4 h-4" />,
  },
  {
    title: translations.menu.curriculum,
    link: "#curriculum",
    icon: <MicVocal className="w-4 h-4" />,
  },
  {
    title: translations.menu.about,
    link: "#about",
    icon: <Smile className="w-4 h-4" />,
  },
  {
    title: translations.menu.audience,
    link: "#audience",
    icon: <Users className="w-4 h-4" />,
  },
  {
    title: translations.menu.reviews.button,
    link: "#reviews",
    icon: <Heart className="w-4 h-4" />,
  },
];

export const getContactInfo = (translations) => [
  {
    icon: <Phone className="w-4 h-4 text-primary/70" />,
    text: "054-6638138",
    link: "tel:+972546638138",
  },
  {
    icon: <SiWhatsapp className="w-4 h-4 text-whatsapp/70" />,
    text: translations.menu.info.whatsapp,
    link: translations.menu.info.whatsapp_link,
  },
  {
    icon: <MapPin className="w-4 h-4 text-mocha/70" />,
    text: translations.menu.info.address,
    link: "https://maps.app.goo.gl/RTBnKzHUTjxC7te69",
  },
  { 
    icon: <Video className="w-4 h-4" />, 
    text: translations.menu.info.video 
  },
  { 
    icon: <Clock className="w-4 h-4" />, 
    text: translations.menu.info.hours 
  },
];

export const getSocialLinks = (translations) => [
  {
    icon: (
      <SiInstagram className="w-5 h-5 hover:text-instagram" />
    ),
    link: "https://www.instagram.com/liaddahari/",
    label: "Instagram",
  },
  {
    icon: (
      <SiWhatsapp className="w-5 h-5 hover:text-whatsapp" />
    ),
    link: translations.menu.info.whatsapp_link,
    label: "Whatsapp",
  },
];